"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useIntersectionObserver } from "@/hooks/useIntersectionObserver";
import type { WaveDropsLeaderboardSort } from "@/hooks/useWaveDropsLeaderboard";
import { useWaveDropsLeaderboard } from "@/hooks/useWaveDropsLeaderboard";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import React from "react";
import { WaveLeaderboardDrop } from "./WaveLeaderboardDrop";
import { WaveLeaderboardEmptyState } from "./WaveLeaderboardEmptyState";
import { WaveLeaderboardLoading } from "./WaveLeaderboardLoading";
import { WaveLeaderboardLoadingBar } from "./WaveLeaderboardLoadingBar";
interface WaveLeaderboardDropsProps {
  readonly wave: ApiWave;
  readonly sort: WaveDropsLeaderboardSort;
  readonly onCreateDrop: () => void;
  readonly curatedByGroupId?: string | undefined;
}
export const WaveLeaderboardDrops: React.FC<WaveLeaderboardDropsProps> = t0 => {
  const $ = _c(32);
  const {
    wave,
    sort,
    onCreateDrop,
    curatedByGroupId
  } = t0;
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== curatedByGroupId || $[1] !== sort || $[2] !== wave.id) {
    t1 = {
      waveId: wave.id,
      sort,
      curatedByGroupId
    };
    $[0] = curatedByGroupId;
    $[1] = sort;
    $[2] = wave.id;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    drops,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage
  } = useWaveDropsLeaderboard(t1);
  let t2;
  if ($[4] !== fetchNextPage || $[5] !== hasNextPage || $[6] !== isFetching || $[7] !== isFetchingNextPage) {
    t2 = async () => {
      if (hasNextPage && !isFetching && !isFetchingNextPage) {
        await fetchNextPage();
      }
    };
    $[4] = fetchNextPage;
    $[5] = hasNextPage;
    $[6] = isFetching;
    $[7] = isFetchingNextPage;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const intersectionElementRef = useIntersectionObserver(t2);
  let t3;
  if ($[9] !== pathname || $[10] !== router || $[11] !== searchParams) {
    t3 = drop => {
      const params = new URLSearchParams(searchParams.toString());
      params.set("drop", drop.id);
      router.push(`${pathname}?${params.toString()}`);
    };
    $[9] = pathname;
    $[10] = router;
    $[11] = searchParams;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const onDropClick = t3;
  if (isFetching && drops.length === 0) {
    let t4;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <WaveLeaderboardLoading />;
      $[13] = t4;
    } else {
      t4 = $[13];
    }
    return t4;
  }
  if (drops.length === 0) {
    let t4;
    if ($[14] !== onCreateDrop || $[15] !== wave) {
      t4 = <WaveLeaderboardEmptyState onCreateDrop={onCreateDrop} wave={wave} />;
      $[14] = onCreateDrop;
      $[15] = wave;
      $[16] = t4;
    } else {
      t4 = $[16];
    }
    return t4;
  }
  let t4;
  if ($[17] !== drops || $[18] !== onDropClick || $[19] !== wave) {
    let t5;
    if ($[21] !== onDropClick || $[22] !== wave) {
      t5 = drop_0 => <WaveLeaderboardDrop key={drop_0.id} drop={drop_0} wave={wave} onDropClick={onDropClick} />;
      $[21] = onDropClick;
      $[22] = wave;
      $[23] = t5;
    } else {
      t5 = $[23];
    }
    t4 = drops.map(t5);
    $[17] = drops;
    $[18] = onDropClick;
    $[19] = wave;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  let t5;
  if ($[24] !== isFetchingNextPage) {
    t5 = isFetchingNextPage && <WaveLeaderboardLoadingBar />;
    $[24] = isFetchingNextPage;
    $[25] = t5;
  } else {
    t5 = $[25];
  }
  let t6;
  if ($[26] !== intersectionElementRef) {
    t6 = <div ref={intersectionElementRef} />;
    $[26] = intersectionElementRef;
    $[27] = t6;
  } else {
    t6 = $[27];
  }
  let t7;
  if ($[28] !== t4 || $[29] !== t5 || $[30] !== t6) {
    t7 = <div className="tw-space-y-4">{t4}{t5}{t6}</div>;
    $[28] = t4;
    $[29] = t5;
    $[30] = t6;
    $[31] = t7;
  } else {
    t7 = $[31];
  }
  return t7;
};